import makeStyles from '@mui/styles/makeStyles';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  root: {
    display: isMobile ? 'block' : 'flex',
    height: '100%',
  },
  content: {
    display: 'flex',
    minWidth: 600,
    flexDirection: 'column',
    flexGrow: 1,
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingRight: theme.spacing(3),
  },
  buttonContainer: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'end',
    bottom: 0,
    height: 70,
    width: '90vw',
    padding: theme.spacing(0, 3, 2),
    backgroundColor: theme.palette.grey[700],
  },
}));

export default useStyles;
